<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
    <p style="color: white">Please Wait...While Fetching Data</p>
</ngx-spinner>

<div class="header_second">
    <div class="Dashboard_head ">Coupon Code

        <div>
            <button mat-raised-button color="primary" style="font-size: 14px;
                    margin-right: 15px;" (click)="AddCoupon()"><mat-icon>add</mat-icon>Add</button>
        </div>

    </div>
</div>

<div class="mat-elevation-z8" style="margin: 0.5rem;">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Search</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search" #input>
    </mat-form-field>
    <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort>

            <!-- Position Column -->
            <ng-container matColumnDef="srNo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> SrNo. </th>
                <td mat-cell *matCellDef="let element"> {{element.srNo}} </td>
            </ng-container>

            <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Code </th>
                <td mat-cell *matCellDef="let element"> {{element.code}} </td>
            </ng-container>
            <ng-container matColumnDef="amount">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Discount</th>
                <td mat-cell *matCellDef="let element">
                    <span class="discount-badge" [ngClass]="{
                        'percent': element.coupon_type === 'percentage',
                        'amount': element.coupon_type === 'flat'
                      }">

                        <ng-container *ngIf="element.coupon_type === 'percentage'">
                            {{ element.amount }}%
                        </ng-container>

                        <ng-container *ngIf="element.coupon_type === 'flat'">
                            ₹ {{ element.amount }}
                        </ng-container>

                    </span>
                </td>

            </ng-container>

            <ng-container matColumnDef="coupon_type">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Discount Type </th>
                <td mat-cell *matCellDef="let element"> {{element.coupon_type | titlecase}} </td>
            </ng-container>

            <ng-container matColumnDef="allowed_count">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Allowed Count </th>
                <td mat-cell *matCellDef="let element"> {{element.allowed_count}} </td>
            </ng-container>

            <ng-container matColumnDef="total_count">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Total Count </th>
                <td mat-cell *matCellDef="let element"> {{element.total_count}} </td>
            </ng-container>

            <ng-container matColumnDef="action" stickyEnd justify="end">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Action </th>
                <td mat-cell *matCellDef="let element">
                    <button mat-raised-button color="primary" matTooltip="Edit" style="margin-left: 5px;"
                        (click)="EditCoupon(element.id)">
                        <mat-icon class=" m-0">edit</mat-icon>
                    </button>
                    <button mat-raised-button color="warn" matTooltip="Delete" style="margin-left: 5px;"
                        (click)="DeleteCoupon(element.id)">
                        <mat-icon class=" m-0">delete</mat-icon>
                    </button>

                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <mat-paginator [pageSizeOptions]="[10, 20, 50]" showFirstLastButtons aria-label="Select page of periodic elements">
    </mat-paginator>
</div>